define.alias("shared/components/shared/ui/block", "calendar/components/shared/ui/block");